import { create } from 'zustand';
import type { PluginManifest, PluginClientConfig, InstanceRole } from '@vtak/shared';

/**
 * Plugin config holder — populated from the server manifest by useConfigQuery.
 * Kept as a zustand store (not just query cache) because non-React modules
 * (layer manager, track layers) read `activePlugins` imperatively via getState.
 */
interface PluginState {
  /** Active plugins from the server. */
  activePlugins: PluginClientConfig[];
  /** Instance role from the server manifest. */
  instanceRole: InstanceRole;
  /** Replace the config with a freshly loaded manifest. */
  setConfig: (manifest: PluginManifest) => void;
}

/** Store for active plugin configuration (canonical synchronous source). */
export const usePluginStore = create<PluginState>((set) => ({
  activePlugins: [],
  instanceRole: 'tactical',
  setConfig: (manifest) =>
    set({ activePlugins: manifest.plugins, instanceRole: manifest.instanceRole }),
}));
